require('../brokerMyInvestmentsStocksTable/brokerMyInvestmentsStocksTable.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const Immutable = require('immutable');

const { BrokerMyInvestmentsProductsTable } = require('../brokerMyInvestmentsProductsTable/brokerMyInvestmentsProductsTable');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ constants
const { ESG_PRODUCT } = require('constants/flagBasedFeatures');
const { TYPE_FUNDS } = require('constants/index');

const BrokerMyInvestmentsProductsFunds = props => {
    const { immStocks, type, showCompleteList, isContractSection, immFundsContributionsList } = props;
    
    return (
        <OKTable className="broker-products-table">
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-products-table__name"
                        width="22%"
                    >
                        <FormattedText value="broker-productName" />
                    </OKTableCell>
                    {type === TYPE_FUNDS && <FeatureTogglingRender notAllowedProductKey={ESG_PRODUCT}>
                        <OKTableCell
                            className="broker-products-table__esg-icon"
                            asHeader={true}
                            width="3%"
                        />
                    </FeatureTogglingRender>}
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__titles"
                        width="7%"
                    >
                        <FormattedText value="broker-productSharesInvestmentFunds" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__average-price"
                        width="9%"
                    >
                        <FormattedText value="broker-productAveragePrice" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__capital"
                        width="12%"
                    >
                        <FormattedText value="broker-productInvestedCapital" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__ratio"
                        width="10%"
                    >
                        <FormattedText value="broker-productNATETFs" />
                        <OKTooltip
                            alternativeIcon={true}
                            content="broker-stocksNavInfoTooltip"
                            offset={[0, -15]}
                        />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__value"
                        width="9%"
                    >
                        <FormattedText value="broker-productSharesActualValue" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__earnings"
                        width="11%"
                    >
                        <FormattedText value="broker-productEarnings" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__in-wallet"
                        width="9%"
                    >
                        <FormattedText value="broker-productInWallet" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        className="broker-products-table__actions"
                        width="8%"
                    />
                </OKTableRow>
            </thead>
            <BrokerMyInvestmentsProductsTable
                type={type}
                immStocks={immStocks}
                immFundsContributionsList={immFundsContributionsList}
                showCompleteList={showCompleteList}
                isContractSection={isContractSection}
                pageName={props.pageName}
            />
        </OKTable>
    );
};

BrokerMyInvestmentsProductsFunds.propTypes = {
    immStocks: PropTypes.object,
    type: PropTypes.string,
    showCompleteList: PropTypes.bool,
    alternativeValueColumnTitle: PropTypes.bool,
    isContractSection: PropTypes.bool,
    pageName: PropTypes.string
};

BrokerMyInvestmentsProductsFunds.defaultProps = {
    immStocks: Immutable.List(),
    showCompleteList: false,
    alternativeValueColumnTitle: false,
    isContractSection: false
};

module.exports = BrokerMyInvestmentsProductsFunds;
